<template>
  <f7-page
    name="home"
    :page-content="true"
  >
    <!-- Top Navbar -->
    <f7-navbar class="" :sliding="false">
      <f7-nav-title class="fs-16 text-uppercase" style="color: #ccc;">¿Qué buscas?</f7-nav-title>
      <f7-nav-right>
        <f7-link class="text-madai" href="/buscar/" icon-md="material:search"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="h-210" style="background-image: url('assets/img/banners/identidad.jpg'); background-repeat: no-repeat;">
      <f7-row>
        <f7-col width="30"></f7-col>
        <f7-col width="70" class="text-right p-r-15 p-t-15">
          <div class="text-uppercase bold fs-20">Diseña tu propio</div>
          <div class="text-uppercase bold fs-15">Anillo de compromiso</div>
          <div class="fs-12 m-t-15 m-b-20 bold">
            Empieza con montura o seleccionando un diamante desde nuestra colección con 360° interactivo.
          </div>
          <f7-button href="/compromiso/" class="d-inline" fill raised>Diseña tu anillo</f7-button>
        </f7-col>
      </f7-row>
      <!-- <img class="" src="assets/img/banners/identidad.jpg" alt=""> -->
    </div>

    <f7-block class="m-t-0 m-b-0 p-t-15 p-b-0" style="background-color: #fff;">
      <f7-swiper ref="swiper" class="p-b-60" pagination :params="{speed:500, slidesPerView: 3}">
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Diamantes</div>
          <f7-link class="no-fastclick no-ripple" href="/diamantes/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/diamante.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Compromiso</div>
          <div class="fs-10 badge badge-diamond text-uppercase bold" style="position: absolute; bottom: -47px; left: 50%; transform: translate(-50%, -50%); z-index: 99;">Diamante</div>
          <f7-link class="no-fastclick no-ripple" href="/compromiso/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/compromiso.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Churumbela</div>
          <div class="fs-10 badge badge-diamond text-uppercase bold" style="position: absolute; bottom: -47px; left: 50%; transform: translate(-50%, -50%); z-index: 99;">Diamante</div>
          <f7-link class="no-fastclick no-ripple" href="/churumbela/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/churumbela.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Promesa</div>
          <div class="fs-10 badge badge-diamond text-uppercase bold" style="position: absolute; bottom: -47px; left: 50%; transform: translate(-50%, -50%); z-index: 99;">Diamante</div>
          <f7-link class="no-fastclick no-ripple" href="/promesa/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/promesa.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
         <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Argolla</div>
          <f7-link class="no-fastclick no-ripple" href="/argolla/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/argolla.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Anillos</div>
          <div class="fs-10 badge badge-circonia text-uppercase bold" style="position: absolute; bottom: -47px; left: 50%; transform: translate(-50%, -50%); z-index: 10;">Circonia</div>
          <f7-link class="no-fastclick no-ripple" href="/zirconia/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/zirconia.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Personalizado</div>
          <f7-link class="no-fastclick no-ripple" href="/personalizado/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/personalizado.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Cadenas</div>
          <f7-link class="no-fastclick no-ripple" href="/cadenas/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/cadena.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Aretes</div>
          <f7-link class="no-fastclick no-ripple" href="/aretes/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/aretes.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Pulso</div>
          <f7-link class="no-fastclick no-ripple" href="/pulsera/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/pulsera.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Dijes</div>
          <f7-link class="no-fastclick no-ripple" href="/dijes/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/dijes.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
        <f7-swiper-slide class="text-center">
          <div class="text-center text-uppercase fs-12 m-b-3 bold" style="color: #757575;">Conjuntos</div>
          <f7-link class="no-fastclick no-ripple" href="/conjuntos/">
            <div class="circle margin-auto">
              <img src="assets/img/menu_stories/conjuntos.jpg" alt="" />
              <div class="size-x2">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                  <circle cx="50" cy="50" r="48" />
                </svg>
              </div>
            </div>
          </f7-link>
        </f7-swiper-slide>
      </f7-swiper>
    </f7-block>

    <div class="m-t-20 h-180 p-10" v-if="false">
      <img class="wd-100 d-block elevation-7" src="assets/img/banners/promocion_descuento.jpg" alt="">
    </div>

    <f7-block class="m-t-0">
      <f7-block-title class="titulo text-center" style="background-color: #fff;">
        <div class="fs-20 text-uppercase bold">Personaliza tu</div>
        <div class="fs-20 m-t-10  text-uppercase bold">Anillo de Compromiso</div>
      </f7-block-title>
      <f7-link class="no-ripple" href="/compromiso/">
        <img class="wd-100" src="assets/img/banners/personaliza.jpg" alt="" srcset="">
      </f7-link>
      <f7-row class="m-t-20">
        <f7-col class="text-center bold fs-18">
          ¿Por dónde quieres comenzar?
        </f7-col>
      </f7-row>
      <f7-row class="m-t-20">
        <f7-col width="70">
          <div class="text-uppercase bold fs-20 text-secondary">Escoge tu montura</div>
          <div class="text-uppercase bold fs-14 text-secondary">favorita</div>
          <div class="fs-12 m-t-15 m-b-15 bold">Ve nuestras opciones de montura a través de los filtros de diseño de tu preferencia.</div>
          <f7-button href="/compromiso/" small fill raised>Ver Monturas</f7-button>
        </f7-col>
        <f7-col class="p-t-20" width="30">
          <f7-link href="/compromiso/">
            <img src="assets/img/otros/montura.jpg" alt="" height="100">
          </f7-link>
        </f7-col>
      </f7-row>
      <f7-row class="m-t-35">
        <f7-col class="p-t-20" width="35">
          <f7-link href="/diamantes/">
            <img src="assets/img/otros/diamond.jpg" alt="" height="120">
          </f7-link>
        </f7-col>
        <f7-col class="text-right" width="65">
          <div class="text-uppercase bold fs-20 text-secondary">Escoge tu diamante</div>
          <div class="text-uppercase bold fs-14 text-secondary">con vista a detalle</div>
          <div class="fs-12 m-t-15 m-b-15 bold">Busca tu diamante favorito desde nuestra colección con vista a detalle y 360° interactivo.</div>
          <f7-button href="/diamantes/" small fill raised>Ver Diamantes</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>

    <img class="wd-100 d-block m-b-30" src="assets/img/banners/gia.jpg" alt="">
    <!-- <img class="wd-100 d-block" src="assets/img/banners/envio.jpg" alt=""> -->
    <div class="m-t-20 h-180 p-10">
      <img class="wd-100 d-block elevation-7" src="assets/img/banners/envio.jpg" alt="">
    </div>

    <f7-block class="m-t-0 m-b-30">
      <f7-block-title class="titulo text-center m-b-10" style="background-color: #A58A55;">
        <div class="fs-16 text-uppercase bold" style="color: #fff">Conoce nuestro proceso</div>
      </f7-block-title>
      <f7-block-title class="titulo text-center m-t-10" style="background-color: #fff;">
        <div class="fs-20 text-uppercase bold">Diséñalo</div>
        <div class="fs-20 m-t-10 bold">En cuatro sencillos pasos</div>
      </f7-block-title>
      <!-- <f7-block-title class="fs-14 text-uppercase text-madai bold p-l-10" style="padding: 10px; border-bottom: 2px solid #293061;">Anillos Personalizados</f7-block-title> -->
      <f7-link href="/personalizado/">
        <img class="wd-100" src="assets/img/banners/personalizalo.jpg" alt="">
      </f7-link>
      <div class="text-center m-t-10">
        <f7-button class="d-inline" href="/personalizado/" color="gray" outline>Conoce como</f7-button>
      </div>
    </f7-block>

    <!-- <f7-block class="m-t-0 hide">
      <f7-block-title class="titulo text-center">
        <div class="text-uppercase bold">Promoción del Mes</div>
        <div class="fs-14 m-t-5 cursive">¡No dejes pasar esta oferta!</div>
      </f7-block-title>
      <f7-swiper navigation>
        <f7-swiper-slide class="text-center"><img src="assets/img/banners/promo_03.png" alt="" width="100%" height="100%"></f7-swiper-slide>
        <f7-swiper-slide class="text-center"><img src="assets/img/banners/promo_04.png" alt="" width="100%" height="100%"></f7-swiper-slide>
        <f7-swiper-slide class="text-center"><img src="assets/img/banners/promo_05.png" alt="" width="100%" height="100%"></f7-swiper-slide>
        <f7-swiper-slide class="text-center"><img src="assets/img/banners/promo_06.png" alt="" width="100%" height="100%"></f7-swiper-slide>
      </f7-swiper>
    </f7-block> -->

    <f7-block class="m-t-0 m-b-0">
      <f7-block-title class="titulo text-center" style="background-color: #A58A55;">
        <div class="fs-16 text-uppercase bold" style="color: #fff">Anillos únicos, clientes satisfechos</div>
      </f7-block-title>
      <!-- <f7-swiper navigation>
        <f7-swiper-slide class="text-center"><img src="assets/img/home_carrusel/1.png" alt="" width="100%" height="100%"></f7-swiper-slide>
        <f7-swiper-slide class="text-center"><img src="assets/img/home_carrusel/2.png" alt="" width="100%" height="100%"></f7-swiper-slide>
        <f7-swiper-slide class="text-center"><img src="assets/img/home_carrusel/3.png" alt="" width="100%" height="100%"></f7-swiper-slide>
      </f7-swiper> -->
    </f7-block>

    <div data-pagination='{"el": ".swiper-pagination"}' data-effect="coverflow" data-slides-per-view="auto" data-centered-slides="true" class="swiper-container swiper-init demo-swiper demo-swiper-coverflow">
      <div class="swiper-pagination"></div>
      <div class="swiper-wrapper">
        <div style="background-image:url(assets/img/home_carrusel/1.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/2.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/3.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/4.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/5.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/6.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/7.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/8.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
        <div style="background-image:url(assets/img/home_carrusel/9.jpg)" class="swiper-slide" v-touch:tap="hrefTo('/personalizado/portafolio/')"></div>
      </div>
    </div>

    <f7-block>
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
export default {
  methods: {
    hrefTo (link) {
      return (direction, event) => {
        this.$f7.views.main.router.navigate(link)
      }
    }
  }
}
</script>

<style>

.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px !important;
}

.swiper-container-3d .swiper-pagination-bullet-active {
  background-color: #a58a55;
}

.coverflow .swiper-slide {
  backface-visibility: hidden;
  background-size: cover;
  color: #fff;
}

.demo-swiper-coverflow .swiper-slide {
  width: 65%;
}

.demo-swiper {
  height: 250px;
  left: 50%;
  position: relative;
  transform: translateX(-50%);
}

/* css list with numeber circle background -------------- */
.numberlist{
  width:450px;
}

.numberlist ol{
  counter-reset: li;
  list-style: none;
  *list-style: decimal;
  font: 15px 'trebuchet MS', 'lucida sans';
  padding: 0;
  margin-bottom: 4em;
}

.numberlist ol ol{
  margin: 0 0 0 2em;
}

.numberlist div {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  *padding: .4em;
  margin: .5em 0;
  background: #FFF;
  color: #000;
  text-decoration: none;
  -moz-border-radius: .3em;
  -webkit-border-radius: .3em;
  border-radius: .3em;
  background: #1d224454;
}

.numberlist div:before{
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: #1d2244;
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid #fff;
  text-align: center;
  font-weight: bold;
  -moz-border-radius: 2em;
  -webkit-border-radius: 2em;
  border-radius: 2em;
  color:#FFF;
}
/* End css list with numeber circle background -------------- */

.fadein {
  transition-delay: 3s;
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
      -moz-animation: fadein 2s; /* Firefox < 16 */
      -ms-animation: fadein 2s; /* Internet Explorer */
        -o-animation: fadein 2s; /* Opera < 12.1 */
          animation: fadein 2s;
}

@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.no-padding > ul {
  padding-left: 0 !important;
}

.no-padding > ul > li > .item-content {
  padding: 0 !important;
}

ul > li > .item-content > .item-inner > .item-title {
  font-weight: bold;
}
</style>

<style scoped>
.simple-list li:after, .links-list a:after, .list .item-inner:after {
  width: 0 !important;
}

.titulo {
  background-color: rgb(246, 244, 245);
  color: #343434;
  padding: 20px 0;
  position: relative;
  width: 100%;
}
</style>
